import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SliderIcon(props) {
    return (React.createElement(Svg, { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Circle, { cx: 18, cy: 18, r: 16, fill: "#fff", stroke: props.color || '#1434CB', strokeWidth: 4 }),
        React.createElement(Path, { d: "M10.226 18c0-.376.156-.72.469-1.033l4.6-4.6v11.265l-4.6-4.6c-.313-.313-.47-.657-.47-1.032zM20.929 23.632V12.367l4.6 4.6c.313.313.469.657.469 1.033 0 .375-.156.72-.47 1.032l-4.6 4.6z", fill: props.color || '#1434CB' })));
}
export default SliderIcon;
